export default __webpack_public_path__ + "static/media/plywood-sheets.6340a15e.svg";